import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useCentralStore } from "stores";

export const updateTaskStatus = ({ churchId, taskId, status }) => {
  return axios.patch(`/churches/${churchId}/tasks/${taskId}/status`, {
    status
  });
};

export const useUpdateTaskStatus = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries("tasks");
      setNotification({
        type: "success",
        message: "Task status updated successfully!"
      });
    },
    ...config,
    mutationFn: updateTaskStatus
  });
};
